const backgroundColor = "#222";
const width = "290px";

export const defaultSelectStyles = {
    control: (baseStyles: any, {isDisabled}: any) => ({
        ...baseStyles,
        backgroundColor: isDisabled ?  "#343a40" : backgroundColor,
        width,
        float: "left",
        marginTop: "2px",
        marginLeft: "10px",
        border: "none",
    }),
    menu: (baseStyles: any) => ({
        ...baseStyles,
        backgroundColor,
        color: "#fff",
        position: "absolute",
        top: "33px",
        width,
        marginLeft: "10px"
    }),
    option: (baseStyles: any) => ({
        ...baseStyles,
        backgroundColor,
        ':hover': {
            backgroundColor: "#055"
        },
        ":active": {
            backgroundColor: "rgb(51, 51, 51)",
            color: "#fff"
        }
    }),
    multiValue: (baseStyles: any) => ({
        ...baseStyles,
        backgroundColor: "rgb(51, 51, 51)",
        color: "#fff"
    }),
    singleValue: (baseStyles: any) => ({
        ...baseStyles,
        color: "#fff"
    }),
    multiValueLabel: (baseStyles: any) => ({
        ...baseStyles,
        backgroundColor: "rgb(51, 51, 51)",
        color: "#fff"
    }),
    multiValueRemove: (baseStyles: any) => ({
        ...baseStyles,
        ":hover": {
            backgroundColor: "rgb(69, 75, 81)"
        },
    }),
    input: (baseStyles: any) => ({
        ...baseStyles,
        color: "#fff"
    }),
};

export const seasonSelectStyles = {
    ...defaultSelectStyles,
    control: (baseStyles: any, {isDisabled}: any) => ({
        ...defaultSelectStyles.control(baseStyles, {isDisabled}),
        width: "98%",
    }),
    menu: (baseStyles: any) => ({
        ...defaultSelectStyles.menu(baseStyles),
        width: "98%",
    }),
};

export const yearSelectStyles = {
    ...defaultSelectStyles,
    control: (baseStyles: any, {isDisabled}: any) => ({
        ...defaultSelectStyles.control(baseStyles, {isDisabled}),
        width: "100%",
    }),
    menu: (baseStyles: any) => ({
        ...defaultSelectStyles.menu(baseStyles),
        width: "100%",
        height: "85vh"
    }),
    menuList: (baseStyles: any) => ({
        ...defaultSelectStyles.menu(baseStyles),
        width: "96%",
        height: "85vh",
        maxHeight: "85vh",
        top: 0
    }),
};

export const listTypeSelectStyles = {
    ...defaultSelectStyles,
    control: (baseStyles: any,  {isDisabled}: any) => ({
        ...defaultSelectStyles.control(baseStyles, {isDisabled}),
        width: "100%",
        marginLeft: 0
    }),
    menu: (baseStyles: any) => ({
        ...defaultSelectStyles.menu(baseStyles),
        width: "100%",
        marginLeft: 0
    }),
}

export const settingSelectStyles = {
    ...defaultSelectStyles,
    control: (baseStyles: any,  {isDisabled}: any) => ({
        ...baseStyles,
        backgroundColor: isDisabled ?  "#343a40" : backgroundColor,
        width,
        float: "left",
        border: "none",
        marginTop: "2px",
        marginLeft: "10px"
    }),
    menu: (baseStyles: any) => ({
        ...baseStyles,
        backgroundColor,
        color: "#fff",
        position: "absolute",
        top: "33px",
        width,
        marginLeft: "10px"
    }),
    option: (baseStyles: any) => ({
        ...baseStyles,
        backgroundColor,
        ':hover': {
            backgroundColor: "#055"
        }
    })
}
